if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', class ProductModel extends HTMLElement {
    constructor() {
      super();

      this.key = this.dataset.storageKey;
      this.canSetKey = false;

      // SR-CUSTOM (29 Oct 2026): the popup sits over a dimmed backdrop; clicking the backdrop or pressing Escape closes it
      this.addEventListener('click', (e) => { if (e.target === this) this.closePopup(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.closePopup(); });

      // Check first if we have test mode
      if (this.dataset.testMode === 'true') {
        this.openPopupWithDelay(0);
        return;
      }

      // Check if we have form and if user posted the form
      this.form = this.querySelector('form');
      if (this.form && window.location.href.includes(`customer_posted=true#${this.form.id}`) && !sessionStorage.getItem(this.key + '_submitted')) {
        sessionStorage.setItem(this.key + '_submitted', true);
        this.openPopupWithDelay(0);
        return;
      }

      // Check if we can open the popup at all
      // First we check if frequency is per session and if session storage has the key
      if (this.dataset.frequency === 'once' && sessionStorage.getItem(this.key)) {
        return;
      } else if (this.dataset.frequency === 'once') {
        this.canSetKey = 'session';
        this.openPopupIfAllowed();
        return;
      }

      if (!localStorage.getItem(this.key)) {
        this.canSetKey = 'local';
        this.openPopupIfAllowed()
        return;
      } else if (localStorage.getItem(this.key)) {
        const frequency = parseInt(this.dataset.frequency.split('_')[0]); // e.g. 14_days => 14
        const timeNow = this.generateTimeStamp();
        const timeThen = parseInt(localStorage.getItem(this.key));
        const timeDiffInDays = (timeNow - timeThen) / (1000 * 3600 * 24);
        if (timeDiffInDays >= frequency) {
          this.canSetKey = 'local';
          this.openPopupIfAllowed()
        }
        return;
      }
    }

    /**
     * SR-CUSTOM (29 Oct 2026): the theme used to wait for tracking consent (Shopify customerPrivacy) before showing the popup,
     * so visitors who ignored or declined the cookie banner never saw it. A sign-up form the visitor fills in themselves is not
     * tracking, so it now shows for everyone. The only thing stored is the "last shown" time used for the 14-day limit.
     * The popup still waits while another drawer or modal is open, including the cookie banner if it uses one (see openPopup).
     */
    openPopupIfAllowed() {
      this.openPopupWithDelay();
    }

    /**
     * Opens the modal after a delay
     * @param {number} delay
     */
    openPopupWithDelay(delay) {
      delay = delay || this.dataset.delay;
      if (delay === 0) {
        this.openPopup();
      } else {
        setTimeout(() => {
          this.openPopup();
        }, delay);
      }
    }

    /**
     * Opens the modal if no other modals or drawers are open
     */
    openPopup() {
      const bodyHasOverflowHidden = document.body.classList.contains('overflow-hidden');
      if (bodyHasOverflowHidden) {
        this.openPopupWithDelay(3000);
        return;
      }

      if (this.canSetKey === 'session') {
        sessionStorage.setItem(this.key, this.generateTimeStamp());
      } else if (this.canSetKey === 'local') {
        localStorage.setItem(this.key, this.generateTimeStamp());
      }
      this.classList.add('is-open');
    }

    /**
     * SR-CUSTOM: closes the popup (backdrop click or Escape). The close button still works through the theme as before.
     */
    closePopup() {
      const btn = this.querySelector('.popup-close');
      if (btn) { btn.click(); }
      if (this.classList.contains('is-open')) this.classList.remove('is-open');
    }

    /**
     * Generate timestamp
     * @returns {number} UNIX Timestamp
     */
    generateTimeStamp() {
      return new Date().getTime();
    }
  });
}
